export const sage = {
  1: { value: { base: '{colors.sage.light.1}', _dark: '{colors.sage.dark.1}' } },
  2: { value: { base: '{colors.sage.light.2}', _dark: '{colors.sage.dark.2}' } },
  3: { value: { base: '{colors.sage.light.3}', _dark: '{colors.sage.dark.3}' } },
  4: { value: { base: '{colors.sage.light.4}', _dark: '{colors.sage.dark.4}' } },
  5: { value: { base: '{colors.sage.light.5}', _dark: '{colors.sage.dark.5}' } },
  6: { value: { base: '{colors.sage.light.6}', _dark: '{colors.sage.dark.6}' } },
  7: { value: { base: '{colors.sage.light.7}', _dark: '{colors.sage.dark.7}' } },
  8: { value: { base: '{colors.sage.light.8}', _dark: '{colors.sage.dark.8}' } },
  9: { value: { base: '{colors.sage.light.9}', _dark: '{colors.sage.dark.9}' } },
  10: { value: { base: '{colors.sage.light.10}', _dark: '{colors.sage.dark.10}' } },
  11: { value: { base: '{colors.sage.light.11}', _dark: '{colors.sage.dark.11}' } },
  12: { value: { base: '{colors.sage.light.12}', _dark: '{colors.sage.dark.12}' } },
  a1: { value: { base: '{colors.sage.light.a1}', _dark: '{colors.sage.dark.a1}' } },
  a2: { value: { base: '{colors.sage.light.a2}', _dark: '{colors.sage.dark.a2}' } },
  a3: { value: { base: '{colors.sage.light.a3}', _dark: '{colors.sage.dark.a3}' } },
  a4: { value: { base: '{colors.sage.light.a4}', _dark: '{colors.sage.dark.a4}' } },
  a5: { value: { base: '{colors.sage.light.a5}', _dark: '{colors.sage.dark.a5}' } },
  a6: { value: { base: '{colors.sage.light.a6}', _dark: '{colors.sage.dark.a6}' } },
  a7: { value: { base: '{colors.sage.light.a7}', _dark: '{colors.sage.dark.a7}' } },
  a8: { value: { base: '{colors.sage.light.a8}', _dark: '{colors.sage.dark.a8}' } },
  a9: { value: { base: '{colors.sage.light.a9}', _dark: '{colors.sage.dark.a9}' } },
  a10: { value: { base: '{colors.sage.light.a10}', _dark: '{colors.sage.dark.a10}' } },
  a11: { value: { base: '{colors.sage.light.a11}', _dark: '{colors.sage.dark.a11}' } },
  a12: { value: { base: '{colors.sage.light.a12}', _dark: '{colors.sage.dark.a12}' } },
}
